<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Add</p>
    </header>
    <section class="modal-card-body">
      <div>
        <o-tabs>
          <o-tab-item v-model="activeTab" label="Select Existing">
            <div class="block">
              <o-radio v-model="type" native-value="project">
                Project
              </o-radio>
              <o-radio v-model="type" native-value="proposal">
                Proposal
              </o-radio>
            </div>
            <multiselect
                v-model="filtereditems"
                :options="results"
                label="reference_title"
                :can-deselect="true"
                mode="tags"
                track-by="key"
                :multiple="true"
                :value-prop='"key"'
                :object="true"
                :close-on-select="false"
                :filter-results="false"
                :clear-on-select="false"
                :hide-selected="true"
                @search-change="handleSearch"
                :internal-search="false"
                :loading="isLoading"
                :limit="5"
                :max="3"
                :max-height="300"
                :show-no-results="false"
                :show-no-options="false"
                :tag-placeholder="query"
                :tag-position="'bottom'"
                placeholder="Type a search term..."
                :searchable="true"
                @deselect="remove"
            >
              <template #noresults>
                <span>No items found.</span>
              </template>
            </multiselect>
          </o-tab-item>
          <o-tab-item label="Create New">
            <proposal-form
                ref="proposal"
                :item="item"
                :is-modal="true"
            />
          </o-tab-item>
        </o-tabs>
      </div>
      <div class="load" style="display: none">
        <div class="lds-facebook"><div></div><div></div><div></div></div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button
          class="button"
          type="button"
          @click="closeModal"
      >
        Close
      </button>
      <button class="button is-primary" @click="handleSave">Save</button>
    </footer>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import Multiselect from '@vueform/multiselect'
import ProposalForm from './../proposals/Form.vue'

export default {
  components: {Multiselect, ProposalForm},
  computed: {},
  data() {
    return {
      activeTab: 0,
      isLoading: false,
      item: {
        company_id: null,
        contact_id: null,
        project_name: '',
        date_created: moment().format('YYYY-MM-DD'),
      },
      query: '',
      results: [],
      selectedItem: null,
      selectedItems: [],
      filtereditems: [],
      type: 'project',
    }
  },
  methods: {
    addItem(item) {
      this.filtereditems.every(!this.isEqual(item)) && this.filtereditems.push(item)
    },
    getKey({reference_id: id, reference_type: type}) {
      return `${id}-${type}`
    },
    handleSave() {
      switch (this.activeTab) {
        case 0:
          this.$emit('modalButtonClick', this.filtereditems)
          $(this.$el).find("button").attr("disabled", true)
          $(this.$el).find("input").attr("disabled", true)
          $(".load").css("display", "block")
          break
        case 1:
          this.$refs.proposal.handleSaveAndPreview().then(() => {
            this.addItem(this.item)
            this.$emit('modalButtonClick', this.filtereditems)
            this.$parent.$parent.close()
          })
          break
      }
    },
    handleSelect(item) {
      this.addItem(item)
    },
    handleSearch: _.debounce(function (query) {
      if (query && query.length > 1) {
        const type = this.type
        let params = {q: query, type, isWork: true}
        axios.get('/api/search', {params})
            .then(res => {
              this.results = res.data.data.map(i => {
                const {id, title, type} = i
                const item = {reference_id: id, reference_title: title, reference_type: type}
                item.key = this.getKey(item)
                return item
              })
            })
      } else {
        this.results = [];
      }
    }, 250),
    isEqual(item) {
      return i => item.reference_id === i.reference_id && item.reference_type === i.reference_type
    },
    limitText() {
      return `and ${count} other items`
    },
    remove(item) {
      this.filtereditems = this.selectedItems.filter(i => !this.isEqual(item)(i))
    },
    closeModal(){
      this.$parent.$parent.close()
    }
  },
  mounted() {
    if (Array.isArray(this.references)) {
      this.selectedItems = this.references
      this.filtereditems = this.selectedItems
    }
  },
  props: {
    references: {
      default: () => [],
      required: false,
      type: Array,
    },
    closable: {
      default: true,
      required: false,
      type: Boolean,
    }
  },
}
</script>
<style>
.modal-card {
  width: auto !important;
  min-width: 1000px;
  margin: 20px;
}

.lds-facebook {
  display: inline-block;
  position: relative;
  left: 50%;
  width: 80px;
  height: 80px;
}
.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 8px;
  width: 16px;
  background: #019ae0;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.lds-facebook div:nth-child(1) {
  left: 8px;
  animation-delay: -0.24s;
}
.lds-facebook div:nth-child(2) {
  left: 32px;
  animation-delay: -0.12s;
}
.lds-facebook div:nth-child(3) {
  left: 56px;
  animation-delay: 0s;
}
@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 64px;
  }
  50%, 100% {
    top: 24px;
    height: 32px;
  }
}

</style>
// reference_id = 5349
// reference_type = 'proposal' || 'project'

// _______________________________________________--
// |
// |  Add to Work
// |
// |  *Select existing  |  Create new proposal
// |
// |   ______________________________
// |   |Select project / proposal    |
// |   ------------------------------


// API
//      select name, id reference, case project_id when null then 'proposal' else 'project' reference_type from proposals
//      left join projects ....
//      where name like '...'
